import { render } from "./FicheAgent.vue?vue&type=template&id=04d86be0"
import script from "./FicheAgent.vue?vue&type=script&lang=js"
export * from "./FicheAgent.vue?vue&type=script&lang=js"

import "./FicheAgent.vue?vue&type=style&index=0&id=04d86be0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__